export default __webpack_public_path__ + "static/media/svg-1.035ebdf9.svg";